import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import throttle from 'lodash/throttle'
import BigNumber from 'bignumber.js'

import useAuth from 'hooks/useAuth'
import { languageList } from 'config/localization/languages'

import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { usePriceCakeBusd, usePriceBnbBusd, usePriceXttBusd } from 'state/farms/hooks'
import { useXttBusdPrice } from 'hooks/useBUSDPrice'
import { useProfile } from 'state/profile/hooks'

import { Button, Text, useWalletModal } from '@pancakeswap/uikit'

import Overlay from './components/Overlay/Overlay'
import Flex from './components/Box/Flex'
import { useMatchBreakpoints } from './hooks'
import Logo from './widgets/Menu/components/Logo'
import Panel from './widgets/Menu/components/Panel'
import IconButton from './components/Button/IconButton'
import CakePrice from './widgets/Menu/components/CakePrice'
import BnbPrice from './widgets/Menu/components/BnbPrice'
import { BinanceIcon, CogIcon } from './components/Svg'
import Link from './components/Link/Link'

import ThemeSwitcher from './widgets/Menu/components/ThemeSwitcher'
import LangSelector from './widgets/Menu/components/LangSelector'
import SocialLinks from './widgets/Menu/components/SocialLinks'

import UserMenu from './UserMenu'
import XttPrice from './widgets/Menu/components/XttPrice'

// import { NavProps } from "./types";

import { NavProps } from './widgets/Menu/types'

import config, { MENU_HEIGHT, SIDEBAR_WIDTH_REDUCED, SIDEBAR_WIDTH_FULL, MENU_ENTRY_HEIGHT } from './config'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`

const Container = styled.div`
  flex: none;
  padding: 8px 4px;
  background-color: ${({ theme }) => theme.nav.background};
  border-top: solid 2px rgba(133, 133, 133, 0.1);
`

const StyledNav = styled.nav<{ showMenu: boolean }>`
  position: fixed;
  top: ${({ showMenu }) => (showMenu ? 0 : `-${MENU_HEIGHT}px`)};
  left: 0;
  transition: top 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 8px;
  padding-right: 16px;
  width: 100%;
  height: ${MENU_HEIGHT}px;
  background-color: ${({ theme }) => theme.nav.background};
  border-bottom: solid 1px rgba(204, 204, 204, 1);
  z-index: 20;
  transform: translate3d(0, 0, 0);
`

const MenuWrapper = styled.div`
  display: block;

  @media (min-width: 20px) and (max-width: 886px) {
    display: none;
  }
`

const ExtraStyledNav = styled.nav<{ showMenu: boolean }>`
  position: fixed;
  top: ${({ showMenu }) => (showMenu ? `${MENU_HEIGHT}px` : `-${MENU_HEIGHT + 40}px`)};
  left: 0;
  transition: top 0.2s;
  display: none;
  justify-content: space-between;
  align-items: center;
  padding-left: 8px;
  padding-right: 16px;
  width: 100%;
  height: ${MENU_HEIGHT}px;
  background-color: ${({ theme }) => theme.nav.background};
  border-bottom: solid 2px rgba(133, 133, 133, 0.1);
  z-index: 20;
  transform: translate3d(0, 0, 0);

  @media (min-width: 20px) and (max-width: 886px) {
    display: flex;
  }
`

const BodyWrapper = styled.div`
  position: relative;
  display: flex;
  background-color: #000000;
  background: url(images/background.png) no-repeat top right fixed;
  /*background-position: 0px 64px;*/
  @media (min-width: 320px) and (max-width: 480px) {
    background-size: 50%;
  }
`

const Inner = styled.div<{ isPushed: boolean; showMenu: boolean }>`
  flex-grow: 1;
  margin-top: ${({ showMenu }) => (showMenu ? `${MENU_HEIGHT}px` : 0)};
  margin-bottom: 20px;
  transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translate3d(0, 0, 0);
  max-width: 100%;

  ${({ theme }) => theme.mediaQueries.nav} {
    margin-left: ${({ isPushed }) => `${isPushed ? SIDEBAR_WIDTH_FULL : SIDEBAR_WIDTH_REDUCED}px`};
    max-width: ${({ isPushed }) => `calc(100% - ${isPushed ? SIDEBAR_WIDTH_FULL : SIDEBAR_WIDTH_REDUCED}px)`};
  }
`

const MobileOnlyOverlay = styled(Overlay)`
  position: fixed;
  height: 100%;

  ${({ theme }) => theme.mediaQueries.nav} {
    display: none;
  }
`

const SocialEntry = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${MENU_ENTRY_HEIGHT}px;
  padding: 0 16px;
`

const CopyRightWrapper = styled.div<{ isPushed: boolean; showMenu: boolean }>`
  position: fixed;
  // padding-top: ${({ showMenu }) => (showMenu ? '80px' : 0)};
  width: 100%;
  background-color: #d7d7d7;
  max-width: 1200px;
  bottom: 0;
  padding: 10px 30px 10px 10px;
  margin-right: auto;
  margin-left: auto;
  // padding-left: ${({ showMenu }) => (showMenu ? `${SIDEBAR_WIDTH_FULL}px` : 0)};
  text-align: center;
  // right: 0;
  // margin-top: ${({ showMenu }) => (showMenu ? `${MENU_HEIGHT}px` : 0)};
  // transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  // transform: translate3d(0, 0, 0);
  max-width: 100%;

  ${({ theme }) => theme.mediaQueries.nav} {
    // margin-right: ${({ isPushed }) => `${isPushed ? SIDEBAR_WIDTH_FULL : SIDEBAR_WIDTH_REDUCED}px`};
    // width: ${({ isPushed }) => `calc(100% - ${isPushed ? SIDEBAR_WIDTH_FULL : SIDEBAR_WIDTH_REDUCED}px)`};
  }

  @media (min-width: 320px) and (max-width: 768px) {
    padding-left: 0;
  }
`

const SocialLinksWrapper = styled.div`
  padding: 0 10px 0px 0px;
  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
  }
`

const NoteContainer = styled.div`
  flex: none;
  //max-width: 300px;
  padding: 0px 0px;
  //	background-color: ${({ theme }) => theme.nav.background};
  //	border-top: solid 2px rgba(133, 133, 133, 0.1);
`
/*
const Menu: React.FC<NavProps> = ({
  userMenu,
  globalMenu,
  isDark,
  toggleTheme,
  langs,
  setLang,
  currentLang,
  cakePriceUsd,
  links,
  children,
}) => {
*/

const UserGuideMenu = styled.a`
  padding: 0px 0px;
  margin-right: 15px;
  color: #18304a;
  ul {
    display: none;
    position: absolute;
    padding-top: 15px;
    @media (min-width: 320px) and (max-width: 768px) {
      display: block;
    }

    li {
      list-style: none;
      padding: 10px 0px;
      background-color: white;
      padding: 10px;
    }
    li:hover {
      background-color: #0086ff;
      a {
        color: white;
      }
    }
  }
  :hover {
    color: #0086ff;
    ul {
      display: block;
    }
  }
`

const Menu: React.FC = ({ children }) => {
  const { login, logout } = useAuth()
  const { isDark, toggleTheme } = useTheme()

  const location = useLocation()

  const cakePriceUsd = usePriceCakeBusd()
  const bnbPriceUsd = usePriceBnbBusd()
  const xttPriceUsd = usePriceXttBusd()

  const { profile } = useProfile()
  const { currentLanguage, setLanguage, t } = useTranslation()
  const links = config(t)

  const { isXl } = useMatchBreakpoints()
  const isMobile = isXl === false
  const [isPushed, setIsPushed] = useState(!isMobile)
  const [showMenu, setShowMenu] = useState(true)
  const refPrevOffset = useRef(window.pageYOffset)

  const { onPresentConnectModal } = useWalletModal(login, logout)

  const [showUserGuideMenu, setShowUserGuideMenu] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const currentOffset = window.pageYOffset
      const isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight
      const isTopOfPage = currentOffset === 0
      // Always show the menu when user reach the top
      if (isTopOfPage) {
        setShowMenu(true)
      }
      // Avoid triggering anything at the bottom because of layout shift
      else if (!isBottomOfPage) {
        if (currentOffset < refPrevOffset.current) {
          // Has scroll up
          setShowMenu(true)
        } else {
          // Has scroll down
          setShowMenu(false)
        }
      }
      refPrevOffset.current = currentOffset
    }
    const throttledHandleScroll = throttle(handleScroll, 200)

    window.addEventListener('scroll', throttledHandleScroll)
    return () => {
      window.removeEventListener('scroll', throttledHandleScroll)
    }
  }, [])

  // Find the home link if provided
  const homeLink = links.find((link) => link.label === 'Home')

  return (
    <Wrapper
      onClick={() => {
        if (showUserGuideMenu) {
          setShowUserGuideMenu(false)
        }
      }}
    >
      <ExtraStyledNav showMenu={showMenu}>
        <Flex style={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <Link
            style={{
              marginRight: '0px',
              fontSize: '15px',
              color: location.pathname === '/about' ? '#0086ff' : '#18304a',
              textAlign: 'center',
            }}
            href="https://xtsunami.com/#aboutus"
          >
            {t('About us').toUpperCase()}
          </Link>
          <Link
            style={{
              marginRight: '0px',
              fontSize: '15px',
              color: location.pathname === '/' ? '#0086ff' : '#18304a',
              textAlign: 'center',
            }}
            href="/"
          >
            {t('Subscription').toUpperCase()}
          </Link>
          <Link
            style={{
              marginRight: '0px',
              fontSize: '15px',
              color: location.pathname === '/download' ? '#0086ff' : '#18304a',
              textAlign: 'center',
            }}
            href="https://xtsunami.com/download/"
          >
            {t('Download').toUpperCase()}
          </Link>

          {/* <Link
            style={{
              marginRight: '0px',
              fontSize: '15px',
              color: location.pathname === '/' ? '#0086ff' : '#18304a',
              textAlign: 'center',
            }}
            href="https://xtblock.gitbook.io/"
          >
            {t('User Guide').toUpperCase()}
          </Link> */}
          <UserGuideMenu
            onClick={() => {
              if (showUserGuideMenu) {
                setShowUserGuideMenu(false)
              } else {
                setShowUserGuideMenu(true)
              }
            }}
          >
            {t('User Guide').toUpperCase()}
            {showUserGuideMenu && (
              <ul>
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://xtblock.gitbook.io/share-stock-cfds-trading-bot/"
                  >
                    Share CFD Bot
                  </a>
                </li>
                <li>
                  <a target="_blank" rel="noopener noreferrer" href="https://xtblock.gitbook.io/forex-trading-bot/">
                    Forex Bot
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://xtblock.gitbook.io/crypto-futures-trading-bot/"
                  >
                    Crypto Futures Bot
                  </a>
                </li>
              </ul>
            )}
          </UserGuideMenu>

          {/* <Link
            style={{
              marginRight: '0px',
              fontSize: '15px',
              color: location.pathname === 'https://backtest.xtsunami.com' ? '#0086ff' : '#18304a',
              textAlign: 'center',
            }}
            href="https://backtest.xtsunami.com"
            target="_blank"
          >
            {t('Backtest').toUpperCase()}
          </Link> */}

          <Link
            style={{
              fontSize: '15px',
              textAlign: 'center',
              color: location.pathname === '/term' ? '#0086ff' : '#18304a',
            }}
            // href="/term"
            href="https://xtsunami.com/terms-of-service/"
          >
            {t('Terms & Conditions').toUpperCase()}
          </Link>
        </Flex>
      </ExtraStyledNav>
      <StyledNav showMenu={showMenu}>
        <Link href="https://xtsunami.com/">
          <Logo
            isPushed={isPushed}
            togglePush={() => setIsPushed((prevState: boolean) => !prevState)}
            isDark={isDark}
            href="http://xtsunami.com/"
          />
        </Link>
        <Flex style={{ alignItems: 'center' }}>
          <MenuWrapper>
            <Flex style={{ marginRight: '30px' }}>
              <Link
                style={{
                  marginRight: '10px',
                  fontSize: '15px',
                  color: location.pathname === '/about' ? '#0086ff' : '#18304a',
                }}
                href="https://xtsunami.com/#aboutus"
              >
                {t('About us').toUpperCase()}
              </Link>
              <Link
                style={{
                  marginRight: '10px',
                  fontSize: '15px',
                  color: location.pathname === '/' ? '#0086ff' : '#18304a',
                }}
                href="/"
              >
                {t('Subscription').toUpperCase()}
              </Link>
              <Link
                style={{
                  marginRight: '10px',
                  fontSize: '15px',
                  color: location.pathname === '/download' ? '#0086ff' : '#18304a',
                }}
                href="https://xtsunami.com/download/"
              >
                {t('Download').toUpperCase()}
              </Link>
              {/* <Link
                style={{
                  marginRight: '10px',
                  fontSize: '15px',
                  color: location.pathname === '/userGuide' ? '#0086ff' : '#18304a',
                }}
                href="https://xtblock.gitbook.io/"
              >
                {t('User Guide').toUpperCase()}
              </Link> */}
              <UserGuideMenu>
                {t('User Guide').toUpperCase()}
                <ul>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://xtblock.gitbook.io/share-stock-cfds-trading-bot/"
                    >
                      Share CFD Bot
                    </a>
                  </li>
                  <li>
                    <a target="_blank" rel="noopener noreferrer" href="https://xtblock.gitbook.io/forex-trading-bot/">
                      Forex Bot
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://xtblock.gitbook.io/crypto-futures-trading-bot/"
                    >
                      Crypto Futures Bot
                    </a>
                  </li>
                </ul>
              </UserGuideMenu>
              {/* <Link
                style={{
                  marginRight: '10px',
                  fontSize: '15px',
                  color: location.pathname === 'https://backtest.xtsunami.com' ? '#0086ff' : '#18304a',
                }}
                href="https://backtest.xtsunami.com"
                target="_blank"
              >
                {t('Backtest').toUpperCase()}
              </Link> */}

              <Link
                style={{
                  fontSize: '15px',
                  color: location.pathname === '/term' ? '#0086ff' : '#18304a',
                }}
                // href="/term"
                href="https://xtsunami.com/terms-of-service/"
              >
                {t('Terms & Conditions').toUpperCase()}
              </Link>
            </Flex>
          </MenuWrapper>
          <Button
            as="button"
            scale={isMobile ? 'xs' : 'sm'}
            style={{
              backgroundColor: '#00acf3',
              backgroundImage: 'linear-gradient(to right, #00acf3, #00acf3)',
              marginRight: `${isMobile ? '0px' : '10px'}`,
            }}
          >
            <XttPrice xttPriceUsd={xttPriceUsd.toNumber()} />
          </Button>
        </Flex>
      </StyledNav>

      <BodyWrapper>
        <Inner isPushed={isPushed} showMenu={showMenu}>
          {children}
        </Inner>
        <CopyRightWrapper isPushed={isPushed} showMenu={showMenu}>
          <Text>
            <a target="_blank" rel="noopener noreferrer" href="https://xtblock.io">
              {t('© Developed by XTblock @2021')}
            </a>
          </Text>
        </CopyRightWrapper>
        <MobileOnlyOverlay show={isPushed} onClick={() => setIsPushed(false)} role="presentation" />
      </BodyWrapper>
    </Wrapper>
  )
}

export default Menu
